<template>
  <button
    :type="type || 'button'"
    class="rounded-full border px-5 py-2 text-base font-medium"
  >
    <slot></slot>
  </button>
</template>

<script setup lang="ts">
const props = defineProps<{
  type?: string;
}>();
</script>
